import { render, staticRenderFns } from "./ecosystem-switcher-modal.vue?vue&type=template&id=57ad9ce2"
import script from "./ecosystem-switcher-modal.ts?vue&type=script&lang=js&external"
export * from "./ecosystem-switcher-modal.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports